import { useAppTemplateContext } from '@components/v2/layout/AppTemplate/contexts/AppTemplate.context';
import Icon from '@components/v2/ui/Icon/Icon';
import ListItemButton from '@components/v2/ui/List/ListItemButton';
import ListItemIcon from '@components/v2/ui/List/ListItemIcon';
import ListItemText from '@components/v2/ui/List/ListItemText';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { LogOut } from 'lucide-react';
import { useHistory } from 'react-router-dom';
import LangEnum from '../../../../../lang/LangEnum';
import { useNetworkContext } from '../../../../../modules/offline/contexts/network/network.context';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { OfflineTestIds } from '../../../../../utils/testIds/Offline.testIds';
import PATHS from '../../../../routes.const';
import { useLeaveOfflineModeButtonStyles } from './leaveOfflineModeButton.styles';

const LeaveOfflineModeButton = () => {
  const { classes, cx } = useLeaveOfflineModeButtonStyles();
  const { translate } = useTranslation();
  const history = useHistory();
  const { sidebarState } = useAppTemplateContext();
  const { userHasInternet, setIsForcingOfflineMode } = useNetworkContext();

  const isCollapsed = sidebarState === 'collapsed';
  const label = translate(LangEnum.GLOBAL_EXIT_OFFLINE_MODE);

  const leaveOfflineMode = () => {
    if (userHasInternet) {
      setIsForcingOfflineMode({ forceOfflineMode: false });
      return;
    }

    history.push(PATHS.offline.loggedNoData.path);
  };

  return (
    <Tooltip TooltipContent={isCollapsed ? label : ''} placement="right" fullWidth>
      <ListItemButton
        testId={OfflineTestIds.LEAVE_OFFLINE_BUTTON}
        className={cx(classes.button, isCollapsed && classes.buttonCollapsed)}
        onClick={leaveOfflineMode}
      >
        <ListItemIcon className={cx(!isCollapsed && classes.icon)}>
          <Icon icon={LogOut} />
        </ListItemIcon>
        {!isCollapsed && (
          <ListItemText
            primary={
              <Typography noWrap color="inherit">
                {label}
              </Typography>
            }
          />
        )}
      </ListItemButton>
    </Tooltip>
  );
};

export default LeaveOfflineModeButton;
